import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getReviewRatingList = (reviewData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_REVIEW_RATING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rating-review-panel/list`,
        reviewData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_REVIEW_RATING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_REVIEW_RATING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_REVIEW_RATING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addReviewRating = (reviewData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REVIEW_RATING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/rating-review-panel/add`,
        reviewData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REVIEW_RATING_SUCCESS", payload: data });
        toast.success("Review Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_REVIEW_RATING_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "ADD_REVIEW_RATING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editReviewRating = (reviewData, id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_REVIEW_RATING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/rating-review-panel/update/${id}`,
        reviewData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_REVIEW_RATING_SUCCESS", payload: data });
        toast.success("Review Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_REVIEW_RATING_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "EDIT_REVIEW_RATING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewReviewRating = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_REVIEW_RATING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(`${BASE_URL}/rating-review-panel/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_REVIEW_RATING_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_REVIEW_RATING_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_REVIEW_RATING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteReviewRating = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_REVIEW_RATING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.delete(`${BASE_URL}/rating-review-panel/remove/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_REVIEW_RATING_SUCCESS", payload: data });
        toast.success("Review Deleted Successfully!!");
        return data;
      } else {
        dispatch({ type: "DELETE_REVIEW_RATING_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "DELETE_REVIEW_RATING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
